import { useEffect, useState } from 'react';
import { superAdminApi } from '../../services/api';

interface Module {
    id: string;
    slug: string;
    name: string;
    description?: string;
    isActive: boolean;
}

export default function ModulesPage() {
    const [modules, setModules] = useState<Module[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        loadModules();
    }, []);

    async function loadModules() {
        try {
            const data = await superAdminApi.listModules();
            setModules(data.modules || []);
        } catch (error) {
            console.error('Failed to load modules:', error);
        } finally {
            setLoading(false);
        }
    }

    if (loading) {
        return <div className="text-center py-8">Loading modules...</div>;
    }

    return (
        <div>
            <h1 className="text-2xl font-bold mb-6">Modules</h1>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                {modules.map((module) => (
                    <div key={module.id} className="bg-gray-800 rounded-lg p-4 border border-gray-700">
                        <div className="flex items-center gap-3 mb-3">
                            <span className="text-2xl">
                                {module.slug === 'bingo' ? '🎯' : module.slug === 'leave_tracker' ? '📅' : '🧩'}
                            </span>
                            <div>
                                <h3 className="font-semibold">{module.name}</h3>
                                <p className="text-xs text-gray-400">{module.slug}</p>
                            </div>
                        </div>
                        <p className="text-sm text-gray-400 mb-3">{module.description || 'No description'}</p>
                        <div className="flex items-center justify-between">
                            <span className={`text-xs px-2 py-1 rounded ${module.isActive ? 'bg-green-600' : 'bg-gray-600'}`}>
                                {module.isActive ? 'Active' : 'Inactive'}
                            </span>
                        </div>
                    </div>
                ))}
            </div>

            {modules.length === 0 && (
                <div className="text-center py-8 text-gray-400">
                    No modules found
                </div>
            )}
        </div>
    );
}
